<div class="role3-110000-form-container">
  <p-toast></p-toast>
  <app-sheet-loader [visible]="isLoading" />

  <p-card [header]="formTitle" [subheader]="isDev ? '[110000] Disclosure - Involvement in Stock Exchange' : ''" *ngIf="!isLoading && stockExchangeForm" class="form-card">
    
    <div class="bg-gray-200 text-black-700 text-sm font-medium px-3 py-1">Disclosure on involvement in stock exchange</div>
    
    <form [formGroup]="stockExchangeForm">
      <!-- Dynamic field rendering - iterate through all controls -->
      <ng-container *ngFor="let control of schema.controls">
        <div class="form-field" *ngIf="shouldShowField(control)">
          <label class="field-label" [class.required]="isFieldRequired(control)">
            {{ control.label }}<app-required-marker [when]="isFieldRequired(control)" />
            <!-- <span class="warning-mark" *ngIf="hasWarnings(control.qname)">*</span> -->
          </label>

          <!-- Dropdown/Select Control -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'select'">
            <p-select
              [formControlName]="control.qname"
              [options]="getDropdownOptions(control.ui.enumSource)"
              optionLabel="label"
              optionValue="value"
              [placeholder]="control | placeholder: 'Please select'"
              class="w-full"
              [filter]="true"
              filterPlaceholder="Search..."
              [showClear]="true"
            ></p-select>

            <!-- Warning Messages (no error validators - all validations are warnings only) -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Date Picker Control -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'date'">
            <p-datepicker
              [inputId]="control.qname"
              [formControlName]="control.qname"
              dateFormat="yy-mm-dd"
              [showIcon]="true"
              iconDisplay="input"
              [placeholder]="control | fixedPlaceholder: 'Select a date'"
              class="w-full"
              (onInput)="onInputChange($event)"
            ></p-datepicker>

            <!-- Warning Messages (no error validators - all validations are warnings only) -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Rich-text (WYSIWYG) field — same preview + pop-out editor as role
               750000 (AS-897). type: TextBlock; always visible (#f6 lost its
               `conditional` block on 2026-07-17), so nothing strips it from the
               submit blob. Warning-only field (no hard error block, consistent
               with this sheet — as of 2026-08-04 NO role-3 field is conditionally
               hidden). -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'richtext'">
            <app-rich-text-field
              [formControlName]="control.qname"
              [title]="control.label"
              [placeholder]="control | placeholder: 'Click to add content…'"
            ></app-rich-text-field>

            <!-- Warning Messages (no error validators - all validations are warnings only) -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Text Input Control -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'text'">
            <input
              type="text"
              pInputText
              [formControlName]="control.qname"
              [placeholder]="control | placeholder"
              class="w-full"
              [maxlength]="getMaxLength(control.qname)"
            />

            <!-- Warning Messages (no error validators - all validations are warnings only) -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>
        </div>
      </ng-container>
    </form>

    <!-- Form Status -->
    <!-- <div *ngIf="!isLoading && schema && stockExchangeForm" class="form-status mt-4">
      <p>
        <strong>Form Status:</strong>
        <span [class]="stockExchangeForm.valid ? 'text-green-600' : 'text-red-600'">
          {{ stockExchangeForm.valid ? 'Valid ✓' : 'Invalid - Please fill required fields' }}
        </span>
      </p>
      <p>
        <strong>Total Fields:</strong> {{ schema.controls.length || 0 }}
      </p>
      <p>
        <strong>Auto-save:</strong>
        <span class="text-green-600">Enabled (500ms debounce)</span>
      </p>
    </div> -->
    <submit-for-validation
      [form]="stockExchangeForm"
      [sheetKey]="'stockExchangeDisclosure'"
      [formTitle]="formTitle"
      (cancelConfirmed)="onCancelConfirmed()"
    ></submit-for-validation>

  </p-card>
</div>
